























































































































































































import {mixins} from "vue-class-component";
import {CommonMixin} from "@/shared/services/mixin";
import {DivisionPickupType, EmployeeType, PickupTargetType} from "../../../enums/type";
import {DivisionPickupStatus, LadingStatus} from "@/enums/status";
import moment from 'moment';
import {DivisionPickupStore} from '../store';
import {DivisionPickupParams, PickupLadingParams} from "@/modules/divisionpickup/params";
import {Component} from "vue-property-decorator";
import DivisionPickupSearch from "@/modules/divisionpickup/List/components/Search.vue";
import PickupTypeLabel from "@/modules/pickup/Pickup/components/PickupTypeLabel.vue";
import DivisionPickupStatusLabel from "@/shared/components/DivisionPickupTypeLabel/index.vue";
import DivisionPickupTableAction from "@/modules/divisionpickup/List/components/TableAction.vue";
import {rejectedDivisionPickup, singleDivisionPickup} from "@/modules/divisionpickup/services";
import {FORMAT_DATE_TIME_PICKER, PAGE_SIZE_OPTIONS} from "@/shared/constant";
import TooltipLabel from "@/shared/components/TooltipLabel/TooltipLabel.vue";
import {RoleDeclare} from "@/enums/roledeclare";

const form = {
  note : undefined
}

const rules = {
  note: [{ required: true, message: "Nhập nội dung." }],
}
@Component({
    name: "DivisionPickup",
    components: {
        TooltipLabel,
        DivisionPickupTableAction, DivisionPickupStatusLabel, PickupTypeLabel, DivisionPickupSearch}
})
export default class extends mixins(CommonMixin){
    EmployeeType = EmployeeType;
    DivisionPickupStatus = DivisionPickupStatus;
    DivisionPickupType = DivisionPickupType;
    PickupTargetType = PickupTargetType;
    LadingStatus = LadingStatus;
    id: undefined;
    visible = false;
    visible1 = false;
    detailPickup = null;
    moment = moment;
    FORMAT_DATE_TIME_PICKER = FORMAT_DATE_TIME_PICKER;
    form = { ...form };
    rules = { ...rules } as any;
    columns = [
        {
            title: "Thao tác",
            dataIndex: "id",
            key: "action",
            scopedSlots: {customRender: "action"},
            width: 160,
            fixed: 'left'
        },
        {
            title: "Ngày yêu cầu",
            dataIndex: "requestDate",
            key: "requestDate",
            width: 150,
            scopedSlots: {customRender: "requestDate"},
            ellipsis: true
        },
        {
            title: "Tổng đơn",
            dataIndex: "numberOfBillLading",
            key: "numberOfBillLading",
            width: 100,
            ellipsis: true
        },
        {
            title: "Tổng trọng lượng (g)",
            dataIndex: "totalWeightOfBillLading",
            key: "totalWeightOfBillLading",
            width: 180,
            ellipsis: true,
            scopedSlots: {customRender: "totalWeightOfBillLading"}
        },
        {
            title: "Mã khách",
            dataIndex: "customer.customerCode",
            key: "customerRowGuid",
            width: 150,
            ellipsis: true,
            scopedSlots: {customRender: "customerCode"}
        },
        {
            title: "Địa chỉ lấy hàng",
            dataIndex: "locationId",
            key: "locationId",
            scopedSlots: {customRender: "location"},
            width: 300,
            ellipsis: true
        },
        {
            title: "Nhân viên lấy đơn",
            dataIndex: "receiveEmployeeRowGuid",
            key: "receiveEmployeeRowGuid",
            scopedSlots: {customRender: "receiveEmployee"},
            width: 180,
            ellipsis: true
        },
        {
            title: "Ngày, giờ điều phối",
            dataIndex: "createdDate",
            key: "createdDate",
            width: 150,
            scopedSlots: {customRender: "createdDate"},
            ellipsis: true
        },
        {
            title: "Nhân viên điều phối",
            dataIndex: "createdBy.employee.fullname",
            key: "createdBy",
            scopedSlots: {customRender: "createdBy"},
            width: 180,
            ellipsis: true
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
            width: 200,
            ellipsis: true
        },
        {
            title: "Đã lấy",
            dataIndex: "numberOfReceiver",
            key: "numberOfReceiver",
            width: 100,
            ellipsis: true
        },
        {
            title: "Lý do huỷ",
            dataIndex: "note",
            key: "note",
            width: 200,
            ellipsis: true
        }
    ];
    columns2 = [
        {
            title: "Ngày, giờ tạo",
            dataIndex: "createdDate",
            key: "createdDate",
            width: 180
        },
        {
            title: "Mã vận đơn",
            dataIndex: "ladingCode",
            key: "ladingCode",
            width: 150
        },
        {
            title: "Mã khách hàng",
            dataIndex: "customer.customerCode",
            key: "customerCode",
            width: 150
        },
        {
            title: "Tên người nhận",
            dataIndex: "locationTo.name",
            key: "",
            width: 150
        },
        {
            title: "SĐT người nhận",
            dataIndex: "locationTo.phoneNumber",
            key: "customerPhone",
            width: 120
        },
        {
            title: "Địa chỉ giao hàng",
            dataIndex: "locationTo",
            key: "locationTo",
            scopedSlots: {customRender: "locationTo"},
            width: 300
        },
        {
            title: "Trạng thái",
            dataIndex: "status",
            key: "status",
            scopedSlots: {customRender: 'status'},
            width: 200
        }


    ]
    limitStatus = [
        DivisionPickupStatus.ChoXacNhan,
        DivisionPickupStatus.XacNhanLay,
        DivisionPickupStatus.ShipperHuy
    ];
    get pickupList() {
        return DivisionPickupStore.ids.map((id: number) => DivisionPickupStore.data[id])
    }

    get pagination() {
        return {
            current: DivisionPickupStore.meta.page,
            pageSize: DivisionPickupStore.meta.limit,
            total: DivisionPickupStore.meta.total,
            showTotal: (total: number) => `Tổng cộng ${total} phân lệnh`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    created() {
        DivisionPickupStore.listDivisionPickup({...new DivisionPickupParams(), statusString:this.limitStatus.join(",")});
    }

    onChangePage(pagination: any) {
        DivisionPickupStore.listDivisionPickup({
            ...DivisionPickupStore.params,
            statusString:this.limitStatus.join(","),
            page: pagination.current,
            limit: pagination.pageSize});
    }

    async seeDetail(id) {
        const {data} = await singleDivisionPickup(id);
        this.detailPickup = data.data
        await DivisionPickupStore.listBillLadingByDivisionPickupId({
            id: id,
            params: new PickupLadingParams()
        })
        this.visible = true;
        this.id = id
    }

  async openRejectPickupModel(id) {
    if (!this.hasPermissionRejectPickup(RoleDeclare.ROLE_CAN_REJECT_ASSIGN_PICKUP)) return;
    this.visible1 = true;
    this.id = id
  }

  async rejectedPickup() {
    if (!this.hasPermissionRejectPickup(RoleDeclare.ROLE_CAN_REJECT_ASSIGN_PICKUP)) return;
    try {
      await rejectedDivisionPickup(this.id, this.form);
      this.$message.success("Xóa điều phối thành công");
    } catch (e) {
      this.$message.error(e?.response?.data?.message || 'Xóa điều phối thất bại');
    }
    this.visible1 = false;
    DivisionPickupStore.listDivisionPickup({...new DivisionPickupParams(), statusString:this.limitStatus.join(",")});
  }

  hasPermissionRejectPickup(role: string) {
    if (!this.hasPermission(role)) {
      this.$notification.error({
        message: "Từ chối truy cập",
        description: "Bạn không có quyền truy cập"
      })
      return false;
    }
    return true
  }

    get billLadingList() {
        return DivisionPickupStore.pickupLadingIds.map((id: string) => DivisionPickupStore.pickupLadings[id])
    }

    get paginationLading() {
        return {
            current: DivisionPickupStore.pickupLadingMeta.page,
            pageSize: DivisionPickupStore.pickupLadingMeta.limit,
            total: DivisionPickupStore.pickupLadingMeta.total,
            showTotal: (total: number) => `Tổng cộng ${total} phân lệnh`,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: PAGE_SIZE_OPTIONS
        }
    }

    onChangePageLading(paginationLading: any) {
        DivisionPickupStore.listBillLadingByDivisionPickupId({
            id: this.id,
            params: {...DivisionPickupStore.pickupLadingParams, page: paginationLading.current}
        });
    }
}
